import { render } from "./CompProdutoRepeticao.vue?vue&type=template&id=74f86c49&scoped=true"
import script from "./CompProdutoRepeticao.vue?vue&type=script&lang=js"
export * from "./CompProdutoRepeticao.vue?vue&type=script&lang=js"

import "./CompProdutoRepeticao.vue?vue&type=style&index=0&id=74f86c49&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f86c49"]])

export default __exports__